type ThemeModeLiteral = 'AUTO' | 'DARK' | 'LIGHT';

type TitleFontWeightLiteral = 'BOLD' | 'LIGHT' | 'REGULAR';

/**
 * `ResponderProjectInput.themeSettings.mode` is a schema-neutral string
 * literal, not either generated `ThemeMode` enum. Typed on the literal
 * values the manager and survey `ThemeMode` enums share rather than either
 * enum itself, so each adapter converts its own enum at the boundary
 * without this lib importing a generated type.
 */
export function toThemeModeLiteral(
  mode: ThemeModeLiteral | null | undefined
): 'LIGHT' | 'DARK' | 'AUTO' | null {
  if (mode === 'DARK') return 'DARK';
  if (mode === 'AUTO') return 'AUTO';
  if (mode === 'LIGHT') return 'LIGHT';

  return null;
}

export function toTitleFontWeightLiteral(
  weight: TitleFontWeightLiteral | null | undefined
): 'LIGHT' | 'REGULAR' | 'BOLD' | null {
  if (weight === 'LIGHT') return 'LIGHT';
  if (weight === 'REGULAR') return 'REGULAR';
  if (weight === 'BOLD') return 'BOLD';

  return null;
}
